export default function isInteractive(type: string): boolean {
  return type !== 'HeadingElement' && type !== 'ContentElement';
}
